export default __webpack_public_path__ + "static/media/Masque-ruban-01.6975224d.png";